<template>
    <div>
        <div v-if="!showTable">
            <loading v-if="!showTable" />
        </div>
        <div v-else>
            <b-form-select
                v-model="endOfExercise"
                :options="endOfExerciseOptions"
                class="col-4 mb-3"
                size="sm"
                @change="getData"
            />
            <table class="table table-sm text-center">
                <thead>
                    <tr>
                        <td></td>
                        <td colspan="3">TENUE</td>
                        <td colspan="4">REVISION BG</td>
                        <td colspan="4">SUPERVISION BG</td>
                        <td colspan="4">POINT CLIENT</td>
                        <td colspan="4">LIASSE</td>
                    </tr>
                    <tr>
                        <th class="text-left my-border">Collaborateur</th>
                        <th width="5%">à faire</th>
                        <th width="5%">fait</th>
                        <th width="5%" class="my-border">reste</th>
                        <th width="5%">à faire</th>
                        <th width="5%">fait</th>
                        <th width="5%">reste</th>
                        <th width="5%" class="my-border">faisable</th>
                        <th width="5%">à faire</th>
                        <th width="5%">fait</th>
                        <th width="5%">reste</th>
                        <th width="5%" class="my-border">faisable</th>
                        <th width="5%">à faire</th>
                        <th width="5%">fait</th>
                        <th width="5%">reste</th>
                        <th width="5%" class="my-border">faisable</th>
                        <th width="5%">à faire</th>
                        <th width="5%">fait</th>
                        <th width="5%">reste</th>
                        <th width="5%">faisable</th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="line in lines">
                        <td class="text-left my-border">
                            {{ line.user_name }}
                        </td>
                        <td>
                            <b-link
                                title="Afficher les sociétés"
                                @click="
                                    showClientsModal(
                                        line.tenue.todo.data,
                                        line.user_name
                                    )
                                "
                            >
                                {{ formatNumber(line.tenue.todo.value) }}
                            </b-link>
                        </td>
                        <td>
                            <b-link
                                title="Afficher les sociétés"
                                @click="
                                    showClientsModal(
                                        line.tenue.done.data,
                                        line.user_name
                                    )
                                "
                            >
                                {{ formatNumber(line.tenue.done.value) }}
                            </b-link>
                        </td>
                        <td class="my-border">
                            <b-link
                                title="Afficher les sociétés"
                                @click="
                                    showClientsModal(
                                        line.revision.remaining.data,
                                        line.user_name
                                    )
                                "
                            >
                                {{ formatNumber(line.tenue.remaining.value) }}
                            </b-link>
                        </td>

                        <td>
                            <b-link
                                title="Afficher les sociétés"
                                @click="
                                    showClientsModal(
                                        line.revision.todo.data,
                                        line.user_name
                                    )
                                "
                            >
                                {{ formatNumber(line.revision.todo.value) }}
                            </b-link>
                        </td>
                        <td>
                            <b-link
                                title="Afficher les sociétés"
                                @click="
                                    showClientsModal(
                                        line.revision.done.data,
                                        line.user_name
                                    )
                                "
                            >
                                {{ formatNumber(line.revision.done.value) }}
                            </b-link>
                        </td>
                        <td>
                            <b-link
                                title="Afficher les sociétés"
                                @click="
                                    showClientsModal(
                                        line.revision.remaining.data,
                                        line.user_name
                                    )
                                "
                            >
                                {{
                                    formatNumber(line.revision.remaining.value)
                                }}
                            </b-link>
                        </td>
                        <td class="my-border">
                            <b-link
                                title="Afficher les sociétés"
                                @click="
                                    showClientsModal(
                                        line.revision.donable.data,
                                        line.user_name
                                    )
                                "
                            >
                                {{ formatNumber(line.revision.donable.value) }}
                            </b-link>
                        </td>

                        <td>
                            <b-link
                                title="Afficher les sociétés"
                                @click="
                                    showClientsModal(
                                        line.supervision.todo.data,
                                        line.user_name
                                    )
                                "
                            >
                                {{ formatNumber(line.supervision.todo.value) }}
                            </b-link>
                        </td>
                        <td>
                            <b-link
                                title="Afficher les sociétés"
                                @click="
                                    showClientsModal(
                                        line.supervision.done.data,
                                        line.user_name
                                    )
                                "
                            >
                                {{ formatNumber(line.supervision.done.value) }}
                            </b-link>
                        </td>
                        <td>
                            <b-link
                                title="Afficher les sociétés"
                                @click="
                                    showClientsModal(
                                        line.supervision.remaining.data,
                                        line.user_name
                                    )
                                "
                            >
                                {{
                                    formatNumber(
                                        line.supervision.remaining.value
                                    )
                                }}
                            </b-link>
                        </td>
                        <td class="my-border">
                            <b-link
                                title="Afficher les sociétés"
                                @click="
                                    showClientsModal(
                                        line.supervision.donable.data,
                                        line.user_name
                                    )
                                "
                            >
                                {{
                                    formatNumber(line.supervision.donable.value)
                                }}
                            </b-link>
                        </td>

                        <td>
                            <b-link
                                title="Afficher les sociétés"
                                @click="
                                    showClientsModal(
                                        line.point.todo.data,
                                        line.user_name
                                    )
                                "
                            >
                                {{ formatNumber(line.point.todo.value) }}
                            </b-link>
                        </td>
                        <td>
                            <b-link
                                title="Afficher les sociétés"
                                @click="
                                    showClientsModal(
                                        line.point.done.data,
                                        line.user_name
                                    )
                                "
                            >
                                {{ formatNumber(line.point.done.value) }}
                            </b-link>
                        </td>
                        <td>
                            <b-link
                                title="Afficher les sociétés"
                                @click="
                                    showClientsModal(
                                        line.point.remaining.data,
                                        line.user_name
                                    )
                                "
                            >
                                {{ formatNumber(line.point.remaining.value) }}
                            </b-link>
                        </td>
                        <td class="my-border">
                            <b-link
                                title="Afficher les sociétés"
                                @click="
                                    showClientsModal(
                                        line.point.donable.data,
                                        line.user_name
                                    )
                                "
                            >
                                {{ formatNumber(line.point.donable.value) }}
                            </b-link>
                        </td>

                        <td>
                            <b-link
                                title="Afficher les sociétés"
                                @click="
                                    showClientsModal(
                                        line.liasse.todo.data,
                                        line.user_name
                                    )
                                "
                            >
                                {{ formatNumber(line.liasse.todo.value) }}
                            </b-link>
                        </td>
                        <td>
                            <b-link
                                title="Afficher les sociétés"
                                @click="
                                    showClientsModal(
                                        line.liasse.done.data,
                                        line.user_name
                                    )
                                "
                            >
                                {{ formatNumber(line.liasse.done.value) }}
                            </b-link>
                        </td>
                        <td>
                            <b-link
                                title="Afficher les sociétés"
                                @click="
                                    showClientsModal(
                                        line.liasse.remaining.data,
                                        line.user_name
                                    )
                                "
                            >
                                {{ formatNumber(line.liasse.remaining.value) }}
                            </b-link>
                        </td>
                        <td>
                            <b-link
                                title="Afficher les sociétés"
                                @click="
                                    showClientsModal(
                                        line.liasse.donable.data,
                                        line.user_name
                                    )
                                "
                            >
                                {{ formatNumber(line.liasse.donable.value) }}
                            </b-link>
                        </td>
                    </tr>
                </tbody>

                <tfoot>
                    <tr>
                        <th class="text-left my-border">TOTAL</th>
                        <th>{{ formatNumber(total.tenue.todo) }}</th>
                        <th>{{ formatNumber(total.tenue.done) }}</th>
                        <th class="my-border">
                            {{ formatNumber(total.tenue.remaining) }}
                        </th>
                        <th>{{ formatNumber(total.revision.todo) }}</th>
                        <th>{{ formatNumber(total.revision.done) }}</th>
                        <th>{{ formatNumber(total.revision.remaining) }}</th>
                        <th class="my-border">
                            {{ formatNumber(total.revision.donable) }}
                        </th>
                        <th>{{ formatNumber(total.supervision.todo) }}</th>
                        <th>{{ formatNumber(total.supervision.done) }}</th>
                        <th>{{ formatNumber(total.supervision.remaining) }}</th>
                        <th class="my-border">
                            {{ formatNumber(total.supervision.donable) }}
                        </th>
                        <th>{{ formatNumber(total.point.todo) }}</th>
                        <th>{{ formatNumber(total.point.done) }}</th>
                        <th>{{ formatNumber(total.point.remaining) }}</th>
                        <th class="my-border">
                            {{ formatNumber(total.point.donable) }}
                        </th>
                        <th>{{ formatNumber(total.liasse.todo) }}</th>
                        <th>{{ formatNumber(total.liasse.done) }}</th>
                        <th>{{ formatNumber(total.liasse.remaining) }}</th>
                        <th>{{ formatNumber(total.liasse.donable) }}</th>
                    </tr>
                </tfoot>
            </table>
        </div>

        <b-modal ref="clients-modal" hide-footer centered :title="modalTitle">
            <div class="clients-container">
                <ul>
                    <li v-for="client in clients" :key="'client' + client.id">
                        {{ client.name }}
                    </li>
                </ul>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { mapState } from 'vuex'

import loading from '../../../common/components/loading'

export default {
    name: 'BalanceGlobal',

    components: {
        loading,
    },

    data() {
        return {
            showTable: false,
            lines: [],
            total: {
                tenue: {},
                revision: {},
                supervision: {},
                point: {},
                liasse: {},
            },
            endOfExercise: 12,
            endOfExerciseOptions: [
                { value: 1, text: 'Fin exercice : 31-jan' },
                { value: 2, text: 'Fin exercice : 28-fév' },
                { value: 3, text: 'Fin exercice : 31-mar' },
                { value: 4, text: 'Fin exercice : 30-avr' },
                { value: 5, text: 'Fin exercice : 31-mai' },
                { value: 6, text: 'Fin exercice : 30-jun' },
                { value: 7, text: 'Fin exercice : 31-jul' },
                { value: 8, text: 'Fin exercice : 31-aou' },
                { value: 9, text: 'Fin exercice : 30-sep' },
                { value: 10, text: 'Fin exercice : 31-oct' },
                { value: 11, text: 'Fin exercice : 30-nov' },
                { value: 12, text: 'Fin exercice : 31-déc' },
            ],
            clients: [],
            modalTitle: '',
        }
    },

    async created() {
        await this.getData()
    },

    methods: {
        initTotal() {
            this.total.tenue.todo = 0
            this.total.tenue.done = 0
            this.total.tenue.remaining = 0

            this.total.revision.todo = 0
            this.total.revision.donable = 0
            this.total.revision.done = 0
            this.total.revision.remaining = 0

            this.total.supervision.todo = 0
            this.total.supervision.donable = 0
            this.total.supervision.done = 0
            this.total.supervision.remaining = 0

            this.total.point.done = 0
            this.total.point.todo = 0
            this.total.point.donable = 0
            this.total.point.remaining = 0

            this.total.liasse.todo = 0
            this.total.liasse.donable = 0
            this.total.liasse.done = 0
            this.total.liasse.remaining = 0
        },

        async getData() {
            this.showTable = false
            try {
                const response = await axios.get(
                    `/dashboard/balance/${this.year}/${this.endOfExercise}`
                )
                this.lines = response.data.data
                this.calculateTotal()
                this.showTable = true
            } catch (error) {
                console.log(error)
            }
        },

        calculateTotal() {
            this.initTotal()

            this.lines.forEach(
                (item) => (this.total.tenue.todo += item.tenue.todo.value)
            )
            this.lines.forEach(
                (item) => (this.total.tenue.done += item.tenue.done.value)
            )
            this.lines.forEach(
                (item) =>
                    (this.total.tenue.remaining += item.tenue.remaining.value)
            )

            this.lines.forEach(
                (item) => (this.total.revision.todo += item.revision.todo.value)
            )
            this.lines.forEach(
                (item) =>
                    (this.total.revision.donable += item.revision.donable.value)
            )
            this.lines.forEach(
                (item) => (this.total.revision.done += item.revision.done.value)
            )
            this.lines.forEach(
                (item) =>
                    (this.total.revision.remaining +=
                        item.revision.remaining.value)
            )

            this.lines.forEach(
                (item) =>
                    (this.total.supervision.todo += item.supervision.todo.value)
            )
            this.lines.forEach(
                (item) =>
                    (this.total.supervision.donable +=
                        item.supervision.donable.value)
            )
            this.lines.forEach(
                (item) =>
                    (this.total.supervision.done += item.supervision.done.value)
            )
            this.lines.forEach(
                (item) =>
                    (this.total.supervision.remaining +=
                        item.supervision.remaining.value)
            )

            this.lines.forEach(
                (item) => (this.total.point.todo += item.point.todo.value)
            )
            this.lines.forEach(
                (item) => (this.total.point.donable += item.point.donable.value)
            )
            this.lines.forEach(
                (item) => (this.total.point.done += item.point.done.value)
            )
            this.lines.forEach(
                (item) =>
                    (this.total.point.remaining += item.point.remaining.value)
            )

            this.lines.forEach(
                (item) => (this.total.liasse.todo += item.liasse.todo.value)
            )
            this.lines.forEach(
                (item) =>
                    (this.total.liasse.donable += item.liasse.donable.value)
            )
            this.lines.forEach(
                (item) => (this.total.liasse.done += item.liasse.done.value)
            )
            this.lines.forEach(
                (item) =>
                    (this.total.liasse.remaining += item.liasse.remaining.value)
            )
        },

        formatNumber(number) {
            return number === 0 ? '-' : number
        },

        async showClientsModal(data, user_name) {
            const url = `/dashboard/balance/${this.year}/${this.endOfExercise}/${data.nth}/${data.accountingFirmUser}/${data.type}`
            try {
                const response = await axios.get(url)
                this.clients = response.data.data
                this.setModalTitle(data, user_name)
                this.$refs['clients-modal'].show()
            } catch (error) {
                console.log(error)
            }
        },

        setModalTitle(data, user_name) {
            let step = ''

            switch (data.nth) {
                case 1:
                    step = 'Tenue'
                    break
                case 2:
                    step = 'Révision BG'
                    break
                case 3:
                    step = 'Supervision BG'
                    break
                case 4:
                    step = 'Point client'
                    break
                case 5:
                    step = 'Liasse'
                    break
                default:
                    step = ''
                    break
            }

            switch (data.type) {
                case 'todo':
                    step += ' à faire'
                    break
                case 'donable':
                    step += ' faisable'
                    break
                case 'done':
                    step += ' fait'
                    break
                case 'remaining':
                    step += ' reste'
                    break
                default:
                    step = ''
                    break
            }

            this.modalTitle = `${step} par ${user_name}`
        },
    },

    computed: {
        ...mapState({
            year: (state) => state.browsing.year,
        }),
    },
}
</script>

<style scoped>
.my-border {
    border-right: 1px solid #ccc;
}

.clients-container {
    max-height: 600px;
    overflow: auto;
}
</style>
